type CachedMethod<This, Value> = (this: This) => Value;

/** Memoizes a zero-argument method per instance: the first call's result is returned on every later call. */
export function Cached() {
    return function <This extends object, Value>(
        method: CachedMethod<This, Value>,
        _context: ClassMethodDecoratorContext<This, CachedMethod<This, Value>>
    ): CachedMethod<This, Value> {
        const results = new WeakMap<This, Value>();
        return function (this: This): Value {
            if (!results.has(this)) {
                results.set(this, method.call(this));
            }
            return results.get(this) as Value;
        };
    };
}

export class UnreachableCaseError extends Error {
    constructor(val: never) {
        super(`Unreachable case: ${JSON.stringify(val)}`);
    }
}
